<template>
   <a v-for="(product, index) in products" :key="index" :href="getProductLink(product.id)">
    <p class="food-text">{{ product.name }}</p></a>
</template>
<script setup>
import { ref, onMounted  } from 'vue';
import axios from 'axios';

const products = ref([]);

onMounted(async () => {
  try {
    const response = await axios.get('suggestedProducts');
    if (response && response.data && response.data.length > 0) {
      const innerArray = response.data[0];
      if (innerArray && innerArray.length > 0) {
        products.value = innerArray;
      }
    }
  } catch (error) {
    console.error('Error fetching products:', error);
  }
});

function getProductLink(productId) {
  return `shop?id=${productId}`;
}

</script>
